export const publishContentSlider = [
  '',
  `mutation publishContentSlider($id:Int!) {
    publishContentSlider(id:$id)
    }
  `,
  'publishContentSlider'];
